import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormLabel,
} from "@material-ui/core";
import { Environment } from "../_generated";
import { Alert } from "@material-ui/lab";

export default function ServiceDeployDialog(props: {
  open: boolean;
  environments: Environment[];
  serviceName: string;
  onCancel: () => any;
  onConfirm: (environmentToDeployInto: Environment) => any;
}) {
  const [environment, selectEnvironment] = useState(
    props.environments[0] as Environment
  );

  return (
    <Dialog open={props.open}>
      <DialogTitle>Deploy Service: {props.serviceName}</DialogTitle>
      <DialogContent>
        <FormLabel component="legend">Environment to deploy to</FormLabel>
        <RadioGroup
          value={environment?.name}
          onChange={(e) =>
            selectEnvironment(
              props.environments.find((env) => env.name === e.target.value)!
            )
          }
        >
          {props.environments.map((env) => (
            <FormControlLabel
              value={env.name}
              control={<Radio />}
              label={env.name}
            />
          ))}
        </RadioGroup>
        <Alert severity="info" style={{ marginTop: 20 }}>
          Latest commit in the default branch will be deployed <br />
          Go to Deployments to see job progress
        </Alert>
        <Alert severity="warning" style={{ marginTop: 10 }}>
          Consider configuring ci branch instead of deploying manually
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onCancel}>Cancel</Button>
        <Button
          variant="contained"
          color="primary"
          disabled={!environment}
          onClick={() => props.onConfirm(environment)}
        >
          Deploy
        </Button>
      </DialogActions>
    </Dialog>
  );
}
